
(function ($) {




  ///////////////////////////////////////////////////////////////////////////
  //moveElementToAnother 1.0
  ///////////////////////////////////////////////////////////////////////////
  //
  //  '.yourClass' is the element that will be moved to a specified element
  //
  /////////////////////////////////////////////////////////
  //                                                    
  //  $('.yourClass').moveElementToAnother({                
  //    // insideBefore: "header .band-menu-panel .feature-wrap-menu", //This will insert '.yourClass' inside the parent of the selected element, --- ABOVE --- the said element
  //    // insideAfter: "header .band-menu-panel .feature-wrap-menu", //This will insert '.yourClass' inside the parent of the selected element, --- BELOW --- the said element
  //    // returnAbove: "1200", // this will return '.yourClass' back to its location --- ABOVE --- 1200px browser width
  //    // returnBelow: "1200" // this will return '.yourClass' back to its location --- BELOW --- 1200px browser width                    
  //  });                                                      
  //                                                     
  /////////////////////////////////////////////////////////
  //

  $.fn.moveElementAround = function (options) {

    var settings = $.extend({
      insideBefore: " ",
      insideAfter: " ",
      returnAbove: "",
      returnBelow: ""
    }, options)




    return this.each(function () {
      var elem = $(this);
      var elemParent = $(this).parents('[class*="-"]');
      var elem2 = elemParent.attr("class").split(" ");
      var elemName = elem2[elem2.length - 1]
      elem.before('<div class="return-' + elemName + '"></div>');
      var width = theWindow.width();

  



      function returnToHome() {
        //
        if ($.isNumeric(settings.returnBelow)) {
          if ($(settings.insideBefore).length > 0 && theWindow.width() > settings.returnBelow) {
            $(elem).detach().insertBefore(settings.insideBefore);
          } else if ($(settings.insideAfter).length > 0 && theWindow.width() < settings.returnBelow) {
            $(elem).detach().insertAfter(settings.insideAfter);
          } else {
            $(elem).detach().insertAfter('.return-' + elemName + '');
          }
        } 
        else if ($.isNumeric(settings.returnAbove)) {
          if ($(settings.insideBefore).length > 0 && theWindow.width() < settings.returnAbove) {
            $(elem).detach().insertBefore(settings.insideBefore);
          } else if ($(settings.insideAfter).length > 0 && theWindow.width() < settings.returnAbove) {
            $(elem).detach().insertAfter(settings.insideAfter);
          } else {
            $(elem).detach().insertAfter('.return-' + elemName + '');
          }

        }

      }



      theWindow.on('window:resize', function () {

        if ($(this).width() != width) {
          width = $(this).width();
          returnToHome();
        }

      });
      returnToHome();




    });


  }

  ///////////////////////////////////////////////////////////////////////////
  //moveElementToAnother 1.0
  ///////////////////////////////////////////////////////////////////////////





})(jQuery); // or even jQuery.noConflict()